import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// ────────────────────────────────
// 아이콘 컴포넌트 (type별 SVG)
// - sale2 추가
// - SVG를 모두 stroke 기반으로 통일 (반응형에서도 아이콘 크기/중심 안정)
// ────────────────────────────────
const MeetingInfoIcon = ({ type }) => {
  return (
    <div className={`meeting_info_icon type_${type}`}>
      {type === 'capacity' && (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="8" cy="9" r="3" />
          <circle cx="16" cy="9" r="3" />
          <path d="M4 18c0-2.2 1.8-4 4-4s4 1.8 4 4" />
          <path d="M12 18c0-2.2 1.8-4 4-4s4 1.8 4 4" />
        </svg>
      )}

      {type === 'price' && (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="4" y="4" width="16" height="16" rx="3" />
          <line x1="9" y1="9" x2="15" y2="9" />
          <line x1="9" y1="13" x2="15" y2="13" />
          <line x1="12" y1="7" x2="12" y2="17" />
        </svg>
      )}

      {type === 'sale' && (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 9l5-5h7l4 4-9 9-7-8z" />
          <circle cx="15" cy="9" r="1.3" />
        </svg>
      )}

      {/* ✅ 가족기업(20% 감면) 전용 아이콘 */}
      {type === 'sale2' && (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 9l5-5h7l4 4-9 9-7-8z" />
          <path d="M10 14l4-4" />
          <circle cx="10.2" cy="10.8" r="1.2" />
          <circle cx="13.8" cy="14.4" r="1.2" />
        </svg>
      )}

      {type === 'equip' && (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="3" y="5" width="18" height="12" rx="2" />
          <line x1="3" y1="13" x2="21" y2="13" />
          <rect x="9" y="18" width="6" height="2" />
        </svg>
      )}
    </div>
  );
};

// ────────────────────────────────
// 좌측 이미지 + 슬라이드 + 우측 카드
// ────────────────────────────────
const MeetingRoomCard = ({ building, roomName, roomDetail, images, infoList }) => {
  const [current, setCurrent] = useState(0);
  const hasMulti = images.length > 1;

  const handlePrev = () => setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  const handleNext = () => setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));

  return (
    <div className="meeting_room_block">
      {/* 좌측 이미지 영역 */}
      <div className="meeting_img_group">
        <div className={`meeting_img ${images[current]}`}></div>

        {hasMulti && (
          <>
            <button type="button" className="meeting_slide_btn meeting_slide_prev" onClick={handlePrev}>
              ‹
            </button>
            <button type="button" className="meeting_slide_btn meeting_slide_next" onClick={handleNext}>
              ›
            </button>
          </>
        )}
      </div>

      {/* 우측 설명 영역 */}
      <div className="meeting_text_area">
        {/* 상단 제목/위치/버튼 */}
        <div className="meeting_top_row">
          <div className="meeting_title_group">
            <span className="meeting_building">{building}</span>
            <span className="meeting_roomname">{roomName}</span>
          </div>

          <div className="meeting_top_right">
            <span className="meeting_room_detail">{roomDetail}</span>
            <button type="button" className="meeting_apply_btn">
              신청하기
            </button>
          </div>
        </div>

        {/* 하단 정보 박스 */}
        <div className="meeting_info_panel">
          {infoList.map((item, idx) => (
            <div className="meeting_info_item" key={idx}>
              <MeetingInfoIcon type={item.type} />
              <div className="meeting_info_text">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const MeetingRoom = () => {
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  const handleSelect = (num) => setSelect((prev) => (prev === num ? 0 : num));
  const moveBoard = (cate) => navigate(`/board/${cate}`, { state: { cate } });
  const movePage = (path) => navigate(path);

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area empty">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}보유시설{' > '}회의실
            </div>
            <div className="banner_main_text">회의실</div>
          </div>
        </div>

        <div className="navi_area">
          <div className="navi_back_wrap">
            <div className="navi_back">
              <div className="navi_box" onClick={() => handleSelect(1)}>
                <div className="navi_main_text">보유시설</div>
                <div className="navi_arrow"></div>
                <div className={`navi_select_box ${select === 1 && 'active'}`}>
                  <div className="select_row" onClick={() => moveBoard('notice')}>
                    알림 및 소식
                  </div>
                  <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                    사업분야
                  </div>
                  <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                    기업연구동
                  </div>
                  <div className="select_row" onClick={() => movePage('/meetingroom')}>
                    보유시설
                  </div>
                  <div className="select_row" onClick={() => movePage('/vision')}>
                    융합원소개
                  </div>
                </div>
              </div>

              <div className="navi_box" onClick={() => handleSelect(2)}>
                <div className="navi_main_text">회의실</div>
                <div className="navi_arrow"></div>
                <div className={`navi_select_box ${select === 2 && 'active'}`}>
                  <div className="select_row" onClick={() => movePage('/meetingroom')}>
                    회의실
                  </div>
                  <div className="select_row" onClick={() => movePage('/computer')}>
                    전산실습실
                  </div>
                  <div className="select_row" onClick={() => movePage('/printing')}>
                    3D프린터
                  </div>
                  <div className="select_row" onClick={() => movePage('/arvr')}>
                    AR/VR
                  </div>
                  <div className="select_row" onClick={() => movePage('/cnc')}>
                    CNC/MCT
                  </div>
                  <div className="select_row" onClick={() => moveBoard('facility')}>
                    시설예약
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ▼ 미팅룸 섹션 */}
        <div className="sub_main_area meetingroom">
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>보유시설</span>
                <div className="center_line"></div>
              </div>
            </div>
            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/meetingroom')}`} onClick={() => movePage('/meetingroom')}>
                <span>회의실</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/computer')}`} onClick={() => movePage('/computer')}>
                <span>전산실습실</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/printing')}`} onClick={() => movePage('/printing')}>
                <span>3D프린터</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/arvr')}`} onClick={() => movePage('/arvr')}>
                <span>AR / VR</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/cnc')}`} onClick={() => movePage('/cnc')}>
                <span>CNC / MCT</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/facility/write')}`}
                onClick={() => movePage('/board/facility/write')}
              >
                <span>시설예약</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          <div className="meeting_section_back meetingroom">
            <div className="meeting_section_container">
              <div className="vision_title_box">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">보유시설 - 회의실</div>
              </div>

              <div className="meeting_guide_box">
                <div className="meeting_guide_title">이용안내</div>
                <ul className="meeting_guide_list">
                  <li>강의장 및 대회의실 (VAT 별도)</li>
                  <li>1시간 미만은 1시간으로 계산</li>
                  <li>주말 및 공휴일 : 20% 가산</li>
                  <li>입주기업 : 50% 할인 / 가족기업 20% 할인</li>
                  <li>대학 및 융합원 주관 행사의 경우 무료로 사용</li>
                </ul>
                <div className="meeting_guide_subtitle">부속설비</div>
                <ul className="meeting_guide_list">
                  <li>전자교탁, 빔 프로젝터 사용료 : 1시간 10,000원</li>
                  <li>전산강의장 컴퓨터 사용료 : 1시간 20,000원</li>
                </ul>
                <p className="meeting_guide_notice">※ 부속설비 사용 시 강의장 및 대회의실 사용 시간 전체에 대해 부과</p>
              </div>

              <MeetingRoomCard
                building="대강의실"
                roomName="106호"
                roomDetail="대강의실 106호"
                images={['meeting_img_106_1', 'meeting_img_106_2']}
                infoList={[
                  { type: 'capacity', text: '최대 60명' },
                  { type: 'price', text: '시간당 40,000원 (VAT 별도)' },
                  { type: 'sale', text: '입주기업 50% 감면' },
                  { type: 'sale2', text: '가족기업 20% 감면' },
                  { type: 'equip', text: '부속설비: 전자교탁, 빔프로젝터, 마이크' },
                ]}
              />

              <MeetingRoomCard
                building="대회의실"
                roomName="202호"
                roomDetail="대회의실 202호"
                images={['meeting_img_202_1', 'meeting_img_202_2']}
                infoList={[
                  { type: 'capacity', text: '최대 19명' },
                  { type: 'price', text: '시간당 30,000원 (VAT 별도)' },
                  { type: 'sale', text: '입주기업 50% 감면' },
                  { type: 'sale2', text: '가족기업 20% 감면' },
                  { type: 'equip', text: '부속설비: 전자교탁, 빔프로젝터, 마이크' },
                ]}
              />
            </div>
          </div>
        </div>
        {/* ▲ 미팅룸 섹션 끝 */}
      </div>
    </div>
  );
};

export default MeetingRoom;
